export default "__VITE_ASSET__BNgJnIny__"